<template>
  <div class="layOut appallContent" v-show="visi">
    <div class="zimuGroup" v-for="(zm, idx) in nowTags" :key="idx">
      <p class="zimu" v-show="tagApps(zm).length > 0">
        <span :id="'tag_' + zm">{{ zm | noNum }}</span>
      </p>
      <ul class="services-list clearfix" v-show="tagApps(zm).length > 0">
        <li v-for="(item, index) in tagApps(zm)" :key="index" class="all_card" @click="toUri(item.uri)">
          <dl class="clearfix">
            <dt>
              <defaultIcon :tag="item.icon" :nowUrI="item.uri" size="s10"/>
              
            </dt>
            <dd>
              <h3 :title="item.name">
                <a href="javascript:;">{{ item.name | noNum }}</a>
              </h3>
              <p>{{ item.department | noNum }}</p>
              <!-- <el-rate :value="parseInt(item.rating / 20)" disabled> </el-rate> -->
            </dd>
            <span class="collect_span xin">
              <collect :id="item.id" iconType="star" lightColor="var(--now)"></Collect>
            </span>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "VariesCard",
  data() {
    return {};
  },
  inject: ["toUri","sortArr","sortArrTags"],
  methods: {
    tagApps(zm) {
      if(zm!='其他分类'){
          return this.metas.filter((item) => item.tags.split(",").length>1&&item.tags.split(",")[1].indexOf(zm)!=-1) || "";
      }else{
          return this.metas.filter((item) => item.tags.split(',').length === 1 || item.tags.split(',')[1] === 'WSXT');
      }
    },
  },
  props:{
    visi:{
      type:Boolean,
      default:()=>{
        return false;
      }
    }
  },
  computed: {
    metas() {
      return this.sortArr(this.$store.getters.getTagApps);
    },
    nowTags(){
      let tags = Object.assign([],this.$store.getters.getOtherTags[1]);
      tags = tags.join(',').replace('WSXT','其他分类').split(",");
      return this.sortArrTags(tags);
    }
  },
};
</script>
<style>
.appallContent {
  background: #ffffff;
  padding-top: 15px;
  margin-bottom: 100px;
  position: fixed;
  left: 165px;
  height: 100vh;
  top: 0px;
  z-index: 10;
  width:862px;
  padding: 20px 10px;
  height:100vh;
  overflow-x:hidden;
  overflow-y: scroll;
}
.pc .el-rate__icon {
 font-size:14px;
 margin-right:1px;
}

</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Cards.vue